__turbopack_context__.v({
  "factItem": "_189dOa_factItem",
  "factLabel": "_189dOa_factLabel",
  "grid": "_189dOa_grid",
});
